export const setUser = (payload) => ({
    type: 'SET_USER',
    payload
});

export const setSiteFontSize = (payload) => ({
    type: 'SET_SITE_FONT_SIZE',
    payload
});
